import { Container, SxProps, Typography } from '@mui/material'
import { Trans } from 'react-i18next'

interface IProps {
  sx?: SxProps
}

export function ProjectsTitle({ sx }: IProps) {
  return (
    <Container maxWidth={'lg'} component="section" id="2" sx={{ ...sx }}>
      <Typography maxWidth={510} variant="h2" mb={{ xs: '28px', md: '100px' }}>
        <Trans ns="widgets" i18nKey="main-page.projects.title" />
      </Typography>
    </Container>
  )
}
